import React, { Component } from 'react';
import ReportPage from './ReportPage';

class EndnotesPage extends Component {
    render() {
        return (
            <ReportPage {...this.props} title="Endnotes" subtitle={"<span>One Choice<sup>&reg;</sup> Target Date Portfolios</span>"} pageNumber={this.props.pageNumber} className="endnotes">
                <p>
                    <b>
                        You should consider the fund's investment objectives, risks, and charges and expenses carefully
                        before you invest. The fund's prospectus or summary prospectus, which can be obtained by
                        visiting <a target="_blank" rel="noopener noreferrer" href="http://www.americancentury.com">www.americancentury.com</a>, contains this and other information about the fund, and should
                        be read carefully before investing.
                    </b>
                </p>
                <p>
                    <b>
                        Data presented reflect past performance. Past performance is no guarantee of future results.
                        Current performance may be higher or lower than the performance shown. Investment return and
                        fund share value will fluctuate, and redemption value may be more or less than original cost. To
                        obtain performance data current to the most recent month-end, please visit <a target="_blank" rel="noopener noreferrer" href="http://www.americancentury.com">americancentury.com</a>.
                        Data assumes reinvestment of dividends and capital gains.
                    </b>
                </p>
                <p className="footnote">
                    The information is not intended as a personalized recommendation or fiduciary advice and should not be relied upon for investment,
                    accounting, legal or tax advice.
                </p>
                <p className="footnote">
                    Past performance does not guarantee future results an 
                    investment return and principal value will fluctuate, so redemption value may be worth more or less than original cost. Total return
                    includes reinvestment of all dividends and capital gains. Returns less than one year are not annualized. Returns presented do not
                    reflect recurring and nonrecurring fees. Fund performance may be subject to substantial short-term changes due to market volatility
                    or other factors. Historically, small cap stocks have been more volatile than the stock of larger, more established companies. For
                    more current month end performance, please visit our website.
                </p>
                <p className="footnote">
                    This information is not intended to serve as investment advice and is subject to change without notice.
                </p>                
                <p className="footnote">
                    ©2020 American Century Proprietary Holdings, Inc. All rights reserved.
                </p>
                <p className="footnote">
                    American Century Investment Services, Inc., Distributor                    
                </p>
            </ReportPage> 
        );
    }
}

export default EndnotesPage;
